import { render, staticRenderFns } from "./InvestPolicyValue.vue?vue&type=template&id=249e76f0&scoped=true"
import script from "./InvestPolicyValue.vue?vue&type=script&lang=js"
export * from "./InvestPolicyValue.vue?vue&type=script&lang=js"
import style0 from "./InvestPolicyValue.vue?vue&type=style&index=0&id=249e76f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249e76f0",
  null
  
)

export default component.exports